import React, { Fragment } from "react";
import classes from "./AdminMain.module.scss";

interface AdminMainProps {
  element: React.ReactNode;
}

const AdminMain: React.FC<AdminMainProps> = ({ element }) => {
  return (
    <Fragment>
      <main className={classes.main}>{element}</main>
    </Fragment>
  );
};

export default AdminMain;
